import { isProd } from './env';

const FIREBASE_CONFIG_DEV = {
  apiKey: 'AIzaSyBPpXM2acsCQqclRxSoGTtK5NYtyeX4uZY',
  authDomain: 'hailuoai-fd23b.firebaseapp.com',
  projectId: 'hailuoai-fd23b',
  storageBucket: 'hailuoai-fd23b.appspot.com',
  messagingSenderId: '849613179111',
  appId: '1:849613179111:web:ba53354d82dca937c9ba42',
  measurementId: 'G-VBVH04H1FR',
};

const FIREBASE_CONFIG_PROD = {
  apiKey: 'AIzaSyB-sV2YX_07UuZTGxpOEcjDHBqoihz1zs0',
  authDomain: 'hailuo-ai.firebaseapp.com',
  projectId: 'hailuo-ai',
  storageBucket: 'hailuo-ai.appspot.com',
  messagingSenderId: '759297274593',
  appId: '1:759297274593:web:3c870e67477b698bd5bda0',
  measurementId: 'G-P4H0FX18F2',
};

export const FIREBASE_CONFIG = isProd ? FIREBASE_CONFIG_PROD : FIREBASE_CONFIG_DEV;

const GOOGLE_CLIENT_ID_DEV =
  '849613179111-jsumti3qf3rlh48df6b8a97ug0ghtvh7.apps.googleusercontent.com';

const GOOGLE_CLIENT_ID_PROD =
  '759297274593-pfid7m24v4g97qss70j7t5ac8u9mre80.apps.googleusercontent.com';

export const GOOGLE_CLIENT_ID = isProd ? GOOGLE_CLIENT_ID_PROD : GOOGLE_CLIENT_ID_DEV;
